import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Menu = () => {
    const { user } = useAuth();

    return (
        <nav className="nxl-navigation">
            <div className="navbar-wrapper">
                <div className="m-header">
                    <a href="index.html" className="b-brand">
                        <img src="./../assets/images/crm-logo.png" alt="CRM Logo" width="100%" className="logo logo-lg" />
                        <img src="./../assets/images/crm-logo-small.png" alt="" className="logo logo-sm" />
                    </a>
                </div>
                <div className="navbar-content">
                    <ul className="nxl-navbar">
                        <li className="nxl-item nxl-caption">
                            <label>Menü</label>
                        </li>
                        {user.Kullanici_Yetki == 0 && (
                            <>
                                <li className="nxl-item">
                                    <a href="./dashboard" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-airplay"></i></span>
                                        <span className="nxl-mtext">Anasayfa</span>
                                    </a>
                                </li>
                                <li className="nxl-item">
                                    <a href="./labels" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-tag"></i></span>
                                        <span className="nxl-mtext">Etiketler</span>
                                    </a>
                                </li>
                                <li className="nxl-item">
                                    <a href="./customer-types" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-users"></i></span>
                                        <span className="nxl-mtext">Müşteri Tipleri</span>
                                    </a>
                                </li>
                                <li className="nxl-item">
                                    <a href="./ads" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-file-text"></i></span>
                                        <span className="nxl-mtext">Reklamlar</span>
                                    </a>
                                </li>
                            </>
                        )}
                        <li className="nxl-item">
                            <a href="./forms" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-clipboard"></i></span>
                                <span className="nxl-mtext">Formlar</span>
                            </a>
                        </li>
                        {user.Kullanici_Yetki == 0 && (
                            <>
                                <li className="nxl-item">
                                    <a href="./reports" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-flag"></i></span>
                                        <span className="nxl-mtext">Rapor Oluştur</span>
                                    </a>
                                </li>
                                <li className="nxl-item">
                                    <a href="./agents" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-users"></i></span>
                                        <span className="nxl-mtext">Temsilciler</span>
                                    </a>
                                </li>
                                <li className="nxl-item">
                                    <a href="./agency-reports" className="nxl-link">
                                        <span className="nxl-micon"><i className="feather-briefcase"></i></span>
                                        <span className="nxl-mtext">Acente Rapor Oluştur</span>
                                    </a>
                                </li>
                            </>
                        )}
                        <li className="nxl-item">
                            <a href="./create-customer" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-user-plus"></i></span>
                                <span className="nxl-mtext">Manuel Müşteri Ekle</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./agencies" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-briefcase"></i></span>
                                <span className="nxl-mtext">Acente Yönetimi Levent</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./agencies?project=gokturk" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-briefcase"></i></span>
                                <span className="nxl-mtext">Acente Yönetimi Göktürk</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Menu;
